import React from "react";
import PropTypes from "prop-types";

const CenteredContainer = ({ children }) => (
    <div className="flex min-h-screen w-full items-center justify-center bg-surface-2 p-4">
        {children}
    </div>
);

CenteredContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default CenteredContainer;
